import { toParamString } from "../utils/UrlUtility";
import { join } from "lodash";
import { doFetch } from "./apiFetchHelper";
import { ONLINE_OPTIONS } from "@Src/constants";

const baseSearchUrl = "/api/search";

export const searchStores = (params) => {
  const {
    phrase,
    selectedCategoryIds,
    distance,
    redemptionMethods,
    resultsPerSearch,
    filterCurrentPage,
    sortBy,
    online,
    offerInfo,
    selectedSubCategory,
    storeKey,
    keyword,
  } = params;

  const offer_offset = offerInfo && offerInfo.offer_offset ? offerInfo.offer_offset : 0;
  const { lat, lon } = params.currentLocation;
  const applyDistanceParams = () => {
    return lat && lon && online !== ONLINE_OPTIONS.ONLY;
  };

  const paramsObj = {
    phrase: keyword || phrase,
    category_key:
      selectedSubCategory.id ||
      (selectedCategoryIds.length > 0 ? join(selectedCategoryIds, ",") : null),
    distance: applyDistanceParams() ? distance : null,
    redemption_method: redemptionMethods.length > 0 ? join(redemptionMethods, ",") : null,
    per_page: resultsPerSearch,
    page: filterCurrentPage,
    sort: sortBy,
    online,
    lat: applyDistanceParams() ? lat : null,
    lon: applyDistanceParams() ? lon : null,
    storeKey,
  };
  if (paramsObj.category_key === 4000) {
    // if grocery coupons category, use phrase "grocery" instead of category_key
    paramsObj.category_key = null;
    paramsObj.phrase = "grocery";
  }
  if (+filterCurrentPage > 1 && +offer_offset > 0) {
    // if > page 1 and offset value is greater than 0, add to search params.
    // needed for correct pagination.. generally only applies when there is a lat/lon
    // and more than 1 page of results.
    paramsObj["offer_offset"] = offer_offset;
  }

  const url = `${baseSearchUrl}?${toParamString(paramsObj)}`;

  return doFetch(url);
};

export const getNearbyLocationsOffers = (payload) => {
  const { distance, lat, lon, category_key, phrase } = payload;

  const paramsObj = {
    distance,
    lat,
    lon,
    phrase,
    ...(!!category_key ? { category_key } : {}),
  };
  return doFetch(`${baseSearchUrl}/locations?${toParamString(paramsObj)}`);
};

export const getSearchSuggestions = (term) => {
  const url = `${baseSearchUrl}/suggestions?term=${term}`;

  return doFetch(url);
};

export const getRecentSearches = () => doFetch(`${baseSearchUrl}/recent`);
